import ResumeUpload from "./ResumeUpload";
import { useAuth } from '../../components/navigation/AuthenticationStateManager';
import NavigationTabBar from '../../components/navigation/NavigationTabBar';
import FooterSection from '../../components/navigation/FooterSection';
import { useNavigate } from 'react-router-dom';
import { Navigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';

export default function ResumeBuilder() {
    const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  // 🔒 Redirect logged-in users away from public resume-builder
  useEffect(() => {
    if (isAuthenticated) {
      navigate("../candidate/resume", { replace: true });
    }
  }, [isAuthenticated, navigate]);
// Prevent flicker
  if (isAuthenticated) return null;

  return (
    <div className="min-h-screen bg-background">
      <NavigationTabBar isAuthenticated={isAuthenticated} />

<main className="pt-16">

  {/* HERO */}
  <section className="rb-hero-pro improved">
    <div className="rb-hero-content">
      <span className="rb-badge">ATS Resume Analyzer</span>

      <h1>
        Get Your Resume Past ATS <br />
        <span>— And Into Interviews</span>
      </h1>

      <p>
        AI-powered resume analysis based on real ATS and recruiter screening
        rules. Get clear, prioritized fixes in <strong>30 seconds</strong>.
      </p>

      <div className="rb-trust-row">
        <span>✔ ATS-safe</span>
        <span>✔ No signup required</span>
        <span>✔ Secure upload</span>
      </div>
    </div>
  </section>

  {/* UPLOAD */}
<section className="rb-main improved">
  <div className="rb-upload-wrapper max-w-4xl mx-auto px-6">
    <ResumeUpload variant="website" />

  </div>
</section>


  {/* HOW IT WORKS */}
  <section className="rb-how-it-works improved">
    <h2>How it works</h2>

    <div className="rb-steps horizontal">
      <Step n="1" title="Upload Resume" desc="PDF or DOCX — under 10 seconds" />
      <Step n="2" title="ATS + Recruiter Scan" desc="Keywords, structure & impact" />
      <Step n="3" title="Fix What Matters" desc="Prioritized improvements" />
    </div>
  </section>

</main>


      <FooterSection />
    </div>
  );
  function Step({ n, title, desc }) {
  return (
    <div className="rb-step">
      <span className="rb-step-num">{n}</span>
      <h4>{title}</h4>
      <p>{desc}</p>
    </div>
  );
}

}
